import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/shared/utils/loader.service';
import { finalize } from 'rxjs/operators';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { BRANDS, LANGUAGES } from 'src/app/shared/models/screen-size.enum';
import { CONSTANTS } from 'src/app/shared/constants/constants';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requestCounter = 0;

  constructor(
    public loaderService: LoaderService,

    private stateManagementService: StateManagementService,
    private injector: Injector
  ) {}

  /**
   * @description resolves the language the user is actually seeing. TranslateService
   * is the source of truth because the redux value is cleared on logout, which would
   * send an empty accept-language and make the backend fall back to en-us while the
   * UI stays French.
   */
  private getPreferredLanguage(): string {
    let currentLang: string | undefined;
    try {
      currentLang = this.injector.get(TranslateService)?.currentLang;
    } catch {
      currentLang = undefined;
    }

    return (
      currentLang ||
      this.stateManagementService?.getUserLanguage() ||
      LANGUAGES.ENGLISH
    );
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req instanceof HttpRequest) {
      const brand = this.stateManagementService?.getUserBrand();
      const language = this.getPreferredLanguage();
      const brandName =
        brand === BRANDS.KWIKSETUNITE
          ? CONSTANTS.KWIKSETUNITE
          : CONSTANTS.WEISERUNITE;

      req = req.clone({
        setHeaders: {
          'x-app-name': `${brandName}`,
          'x-app-ver': 'x',
          'accept-language': `${language}`,
        },
      });
      if (!req.headers.get('loader')) {
        this.requestCounter++;
        this.loaderService.show();

        return next.handle(req).pipe(
          finalize(() => {
            this.requestCounter--;
            if (this.requestCounter === 0) this.loaderService.hide();
          })
        );
      }
    }

    return next.handle(req);
  }
}
